import { reactive } from 'vue'

export default reactive({
	errors: null,
	out: null,
	primaryCurveDiv: null,
	plotSimDiv: null,
	userToggledERSizing: false,
	erEquipmentSelect: false,
})
